// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
export function accessToJson(m) {
    const o = {};
    if (m.scope !== undefined) {
        o['scope'] = m.scope.map(e => e);
    }
    if (m.public !== undefined)
        o['public'] = m.public;
    return o;
}
export function accessFromJson(o) {
    var _a, _b;
    return {
        scope: ((_a = o['scope']) !== null && _a !== void 0 ? _a : []).map(e => e),
        public: (_b = o['public']) !== null && _b !== void 0 ? _b : false,
    };
}
export function mCPOptionsToJson(m) {
    const o = {};
    if (m.serverId !== undefined) {
        o['serverId'] = m.serverId.map(e => e);
    }
    if (m.toolId !== undefined)
        o['toolId'] = m.toolId;
    if (m.requiredFields !== undefined) {
        o['requiredFields'] = m.requiredFields.map(e => e);
    }
    if (m.explicitEmptyResponse !== undefined)
        o['explicitEmptyResponse'] = m.explicitEmptyResponse;
    if (m.public !== undefined)
        o['public'] = m.public;
    if (m.description !== undefined)
        o['description'] = m.description;
    if (m.exampleQueries !== undefined) {
        o['exampleQueries'] = m.exampleQueries.map(e => e);
    }
    if (m.synonyms !== undefined) {
        o['synonyms'] = m.synonyms.map(e => e);
    }
    return o;
}
export function mCPOptionsFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        serverId: ((_a = o['serverId']) !== null && _a !== void 0 ? _a : []).map(e => e),
        toolId: (_b = o['toolId']) !== null && _b !== void 0 ? _b : '',
        requiredFields: ((_c = o['requiredFields']) !== null && _c !== void 0 ? _c : []).map(e => e),
        explicitEmptyResponse: (_d = o['explicitEmptyResponse']) !== null && _d !== void 0 ? _d : false,
        public: (_e = o['public']) !== null && _e !== void 0 ? _e : false,
        description: (_f = o['description']) !== null && _f !== void 0 ? _f : '',
        exampleQueries: ((_g = o['exampleQueries']) !== null && _g !== void 0 ? _g : []).map(e => e),
        synonyms: ((_h = o['synonyms']) !== null && _h !== void 0 ? _h : []).map(e => e),
    };
}
export function dateRangeToJson(m) {
    const o = {};
    if (m.start !== undefined)
        o['start'] = m.start.toISOString();
    if (m.end !== undefined)
        o['end'] = m.end.toISOString();
    return o;
}
export function dateRangeFromJson(o) {
    return {
        start: o['start'] ? new Date(o['start']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        end: o['end'] ? new Date(o['end']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function fieldMaskToJson(m) {
    const o = {};
    if (m.paths !== undefined) {
        o['paths'] = m.paths.map(e => e);
    }
    return o;
}
export function fieldMaskFromJson(o) {
    var _a;
    return {
        paths: ((_a = o['paths']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function geoPointToJson(m) {
    const o = {};
    if (m.latitude !== undefined)
        o['latitude'] = m.latitude;
    if (m.longitude !== undefined)
        o['longitude'] = m.longitude;
    return o;
}
export function geoPointFromJson(o) {
    var _a, _b;
    return {
        latitude: (_a = o['latitude']) !== null && _a !== void 0 ? _a : 0,
        longitude: (_b = o['longitude']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function propertyValueToJson(m) {
    const o = {};
    if (m.property !== undefined)
        o['property'] = m.property;
    if (m.value !== undefined)
        o['value'] = m.value;
    return o;
}
export function propertyValueFromJson(o) {
    var _a, _b;
    return {
        property: (_a = o['property']) !== null && _a !== void 0 ? _a : '',
        value: (_b = o['value']) !== null && _b !== void 0 ? _b : undefined,
    };
}
export function propertyNameToJson(m) {
    const o = {};
    if (m.property !== undefined)
        o['property'] = m.property;
    return o;
}
export function propertyNameFromJson(o) {
    var _a;
    return {
        property: (_a = o['property']) !== null && _a !== void 0 ? _a : '',
    };
}
export function operatorToJson(m) {
    const o = {};
    if (m.operator !== undefined)
        o['operator'] = m.operator;
    if (m.children !== undefined) {
        o['children'] = m.children.map(e => matcherNodeToJson(e));
    }
    return o;
}
export function operatorFromJson(o) {
    var _a, _b;
    return {
        operator: (_a = o['operator']) !== null && _a !== void 0 ? _a : 'BOOLEAN_OPERATOR_AND',
        children: ((_b = o['children']) !== null && _b !== void 0 ? _b : []).map(e => matcherNodeFromJson(e)),
    };
}
export function matcherNodeToJson(m) {
    const o = {};
    if (m.operation !== undefined) {
        if (m.operation.type === 'equal') {
            o['equal'] = propertyValueToJson(m.operation.equal);
        }
        if (m.operation.type === 'operator') {
            o['operator'] = operatorToJson(m.operation.operator);
        }
        if (m.operation.type === 'not') {
            o['not'] = matcherNodeToJson(m.operation.not);
        }
        if (m.operation.type === 'missing') {
            o['missing'] = propertyNameToJson(m.operation.missing);
        }
        if (m.operation.type === 'null') {
            o['null'] = propertyNameToJson(m.operation.null);
        }
        if (m.operation.type === 'subset') {
            o['subset'] = propertyValueToJson(m.operation.subset);
        }
        if (m.operation.type === 'prefix') {
            o['prefix'] = propertyValueToJson(m.operation.prefix);
        }
    }
    else {
        if (m.equal !== undefined)
            o['equal'] = propertyValueToJson(m.equal);
        if (m.operator !== undefined)
            o['operator'] = operatorToJson(m.operator);
        if (m.not !== undefined)
            o['not'] = matcherNodeToJson(m.not);
        if (m.missing !== undefined)
            o['missing'] = propertyNameToJson(m.missing);
        if (m.null !== undefined)
            o['null'] = propertyNameToJson(m.null);
        if (m.subset !== undefined)
            o['subset'] = propertyValueToJson(m.subset);
        if (m.prefix !== undefined)
            o['prefix'] = propertyValueToJson(m.prefix);
    }
    return o;
}
export function matcherNodeFromJson(o) {
    return {
        operation: (() => {
            if (o['equal'] !== undefined)
                return { type: 'equal', equal: o['equal'] ? propertyValueFromJson(o['equal']) : undefined };
            if (o['operator'] !== undefined)
                return { type: 'operator', operator: o['operator'] ? operatorFromJson(o['operator']) : undefined };
            if (o['not'] !== undefined)
                return { type: 'not', not: o['not'] ? matcherNodeFromJson(o['not']) : undefined };
            if (o['missing'] !== undefined)
                return { type: 'missing', missing: o['missing'] ? propertyNameFromJson(o['missing']) : undefined };
            if (o['null'] !== undefined)
                return { type: 'null', null: o['null'] ? propertyNameFromJson(o['null']) : undefined };
            if (o['subset'] !== undefined)
                return { type: 'subset', subset: o['subset'] ? propertyValueFromJson(o['subset']) : undefined };
            if (o['prefix'] !== undefined)
                return { type: 'prefix', prefix: o['prefix'] ? propertyValueFromJson(o['prefix']) : undefined };
            return undefined;
        })(),
        equal: o['equal'] !== undefined ? o['equal'] ? propertyValueFromJson(o['equal']) : undefined : undefined,
        operator: o['operator'] !== undefined ? o['operator'] ? operatorFromJson(o['operator']) : undefined : undefined,
        not: o['not'] !== undefined ? o['not'] ? matcherNodeFromJson(o['not']) : undefined : undefined,
        missing: o['missing'] !== undefined ? o['missing'] ? propertyNameFromJson(o['missing']) : undefined : undefined,
        null: o['null'] !== undefined ? o['null'] ? propertyNameFromJson(o['null']) : undefined : undefined,
        subset: o['subset'] !== undefined ? o['subset'] ? propertyValueFromJson(o['subset']) : undefined : undefined,
        prefix: o['prefix'] !== undefined ? o['prefix'] ? propertyValueFromJson(o['prefix']) : undefined : undefined,
    };
}
export function methodMetadataToJson(m) {
    const o = {};
    if (m.isPublic !== undefined)
        o['isPublic'] = m.isPublic;
    if (m.scopes !== undefined) {
        o['scopes'] = m.scopes.map(e => e);
    }
    return o;
}
export function methodMetadataFromJson(o) {
    var _a, _b;
    return {
        isPublic: (_a = o['isPublic']) !== null && _a !== void 0 ? _a : false,
        scopes: ((_b = o['scopes']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function sDKMetadataToJson(m) {
    const o = {};
    if (m.sdkName !== undefined)
        o['sdkName'] = m.sdkName;
    return o;
}
export function sDKMetadataFromJson(o) {
    var _a;
    return {
        sdkName: (_a = o['sdkName']) !== null && _a !== void 0 ? _a : '',
    };
}
export function pagedRequestOptionsToJson(m) {
    const o = {};
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    return o;
}
export function pagedRequestOptionsFromJson(o) {
    var _a, _b;
    return {
        cursor: (_a = o['cursor']) !== null && _a !== void 0 ? _a : '',
        pageSize: (_b = o['pageSize']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function pagedResponseMetadataToJson(m) {
    const o = {};
    if (m.nextCursor !== undefined)
        o['nextCursor'] = m.nextCursor;
    if (m.hasMore !== undefined)
        o['hasMore'] = m.hasMore;
    if (m.totalResults !== undefined)
        o['totalResults'] = m.totalResults;
    return o;
}
export function pagedResponseMetadataFromJson(o) {
    var _a, _b, _c;
    return {
        nextCursor: (_a = o['nextCursor']) !== null && _a !== void 0 ? _a : '',
        hasMore: (_b = o['hasMore']) !== null && _b !== void 0 ? _b : false,
        totalResults: (_c = o['totalResults']) !== null && _c !== void 0 ? _c : 0,
    };
}
export function propertyToJson(m) {
    const o = {};
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.repeated !== undefined)
        o['repeated'] = m.repeated;
    if (m.properties !== undefined) {
        o['properties'] = m.properties.map(e => propertyToJson(e));
    }
    if (m.piiTag !== undefined)
        o['piiTag'] = m.piiTag;
    if (m.description !== undefined)
        o['description'] = m.description;
    return o;
}
export function propertyFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        name: (_a = o['name']) !== null && _a !== void 0 ? _a : '',
        type: (_b = o['type']) !== null && _b !== void 0 ? _b : 'PROPERTY_TYPE_STRING',
        repeated: (_c = o['repeated']) !== null && _c !== void 0 ? _c : false,
        properties: ((_d = o['properties']) !== null && _d !== void 0 ? _d : []).map(e => propertyFromJson(e)),
        piiTag: (_e = o['piiTag']) !== null && _e !== void 0 ? _e : 'PROPERTY_PII_TAG_CLEAN',
        description: (_f = o['description']) !== null && _f !== void 0 ? _f : '',
    };
}
export function schemaToJson(m) {
    const o = {};
    if (m.properties !== undefined) {
        o['properties'] = m.properties.map(e => propertyToJson(e));
    }
    return o;
}
export function schemaFromJson(o) {
    var _a;
    return {
        properties: ((_a = o['properties']) !== null && _a !== void 0 ? _a : []).map(e => propertyFromJson(e)),
    };
}
export function typedStructToJson(m) {
    const o = {};
    if (m.schema !== undefined)
        o['schema'] = schemaToJson(m.schema);
    if (m.value !== undefined)
        o['value'] = m.value;
    return o;
}
export function typedStructFromJson(o) {
    var _a;
    return {
        schema: o['schema'] ? schemaFromJson(o['schema']) : undefined,
        value: (_a = o['value']) !== null && _a !== void 0 ? _a : {},
    };
}
